import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

export default class extends BridgeComponent {
  static component = "button";
  static values = {
    position: String,
  };

  connect() {
    super.connect();

    const element = this.bridgeElement;
    const iosImage = element.bridgeAttribute("ios-image");
    const androidImage = element.bridgeAttribute("android-image");
    const position = this.positionValue || "right";
    const data = { title: element.title, iosImage, androidImage, position };

    this.send("connect", data, () => {
      this.element.click();
    });
  }

  disconnect() {
    super.disconnect();
    this.send("disconnect");
  }
}
